import { adminSearchShardCatalogDetailsGetSlice } from './post';
import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

export const adminSearchShardCatalogReindexCustomerReducers = combineReducers({
	post: adminSearchShardCatalogDetailsGetSlice.asyncReducers
});

export const adminSearchShardCatalogReindexCustomerWatchers = combineAllWatchers([
	adminSearchShardCatalogDetailsGetSlice.asyncWatchers
]);
